import React from 'react';
import { GridView } from "@mui/icons-material"; // assuming you have this icon
import { CustomElement } from "../../../../../slate";
import { EditorPlugin } from "../../slate/PowerEditorConfig";
import { createWithVoidInjector, generateCode } from "../common";
import { GridBlockElement, GridBlockElementType } from "./GridBlockElement";

// Create the injector (prevents Slate from messing up the void node wrapper)
const withGrid = createWithVoidInjector(GridBlockElementType);

export const GridPlugin: EditorPlugin = {
    key: "grid-block",
    inject: withGrid,
    commands: [{
        name: "insert-grid-block",
        menu: { 
            section: "insert-item", 
            label: "Grid", 
            label_id: "powerdoc.plugins.grid.title", 
            icon: <GridView /> 
        },
        invoke: editor => {
            editor.insertNode({
                type: GridBlockElementType,
                columns: 3, // Default columns
                grid_items: [
                    // Start with one default item
                    { id: generateCode(), content: {}, colSpan: 1, rowSpan: 1 }
                ],
                children: [{ text: "", }], // Void node requires an empty text child
            } as CustomElement);
        }
    }],
    customBlocks: { [GridBlockElementType]: GridBlockElement },
};
